import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, Link } from "react-router-dom";
import ReactGA from "react-ga4"; // Import Google Analytics
import { HelmetProvider, Helmet } from "react-helmet-async"; // Import React Helmet for dynamic head management
import Login from "./Security/Login";
import Signup from "./Security/Signup"; // Correct case
import MainShopifyLink from "./Shopify-Product/Layouts/MainShopifyLink";
import Team from "./Pages/Team";
import BlogPage from "./Components/BlogPage";
import PrivateRoute from "./Security/PrivateRoute";
import Header from "./Components/Header";
import ShopifyShowcase from "./Shopify-Product/Frontend/Layouts/ShopifyShowcase";
import PostDetailsPage from "./Shopify-Product/Frontend/Components/PostDetailsPage";
import Main_root from "./Components/Main_root";
import Aboutus from "./Pages/Aboutus";
import Pagesstructure from "./Pages/Pagesstructure";
import Privacypolicy from "./Pages/Privacypolicy";
import Termandcondiation from "./Pages/Termandcondiation";
import Desclaimer from "./Pages/Desclaimer";
import Contactus from "./Pages/Contactus";

// Layout Component
const Layout = ({ children }) => {
  const location = useLocation();

  // Determine if Header should be shown
  const showHeader = ![
    "/login",
    "/signup",
    "/dashboard",
    "/Shopify-custom-sections",
  ].includes(location.pathname) &&
    !location.pathname.startsWith("/Shopify-custom-sections/post") &&
    location.pathname !== "*"; // Exclude 404
  return (
    <>
      {showHeader && <Header />}
      {children}
    </>
  );
};

// CanonicalTag Component
const CanonicalTag = () => {
  const location = useLocation();
  const canonicalUrl = `https://xebrand.in${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

// Dynamic SEO for Shopify Showcase
const ShopifyShowcaseSEO = () => (
  <Helmet>
    <title>Free Premium Shopify Sections | Designed by Xebrand</title>
    <meta
      name="description"
      content="Discover free premium Shopify sections by Xebrand. Easily enhance your store design with banners, sliders, testimonials, and more."
    />
  </Helmet>
);

// Dynamic SEO for Individual Posts
const PostDetailsSEO = ({ slug }) => (
  <Helmet>
    <title>{`${slug} | Free Shopify Sections by Xebrand`}</title>
    <meta
      name="description"
      content={`Learn more about the ${slug} section, designed by Xebrand to simplify Shopify store customization with premium features.`}
    />
  </Helmet>
);

function App() {
  useEffect(() => {
    // Initialize Google Analytics with your Measurement ID
    ReactGA.initialize("G-5T43N67SV4"); // Replace with your Measurement ID
    ReactGA.send("pageview"); // Track the first page view
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          {/* Add Canonical Tag */}
          <CanonicalTag />

          <Routes>
            {/* Redirect from Homepage */}
            <Route path="/" element={<Main_root />} />

            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            {/* <Route path="/signup" element={<Signup />} /> */}
            
            <Route path="/team" element={<Team />} />
            <Route path="/about" element={<Aboutus />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/term-conditions" element={<Termandcondiation />} />
            <Route path="/disclaimer" element={<Desclaimer />} />
            <Route path="/contact-us" element={<Contactus />} />

            {/* Route for Shopify Showcase */}
            <Route
              path="/Shopify-custom-sections"
              element={
                <>
                  <ShopifyShowcaseSEO />
                  <ShopifyShowcase />
                </>
              }
            />
            <Route
              path="/Shopify-custom-sections/post/:slug"
              element={
                <>
                  <PostDetailsSEO slug="Dynamic Post Title" />
                  <PostDetailsPage />
                </>
              }
            />

            {/* Sitemap Route */}
            <Route
              path="/sitemap.xml"
              element={() => {
                window.location.href = "https://xebrand.in/generate_sitemap.php";
                return null;
              }}
            />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <MainShopifyLink />
                </PrivateRoute>
              }
            />

            {/* Catch-All Route */}
            <Route
              path="*"
              element={
                <div className="flex flex-col items-center justify-center h-screen">
                  <h1 className="text-3xl mb-4">404 - Page Not Found</h1>
                  <Link
                    to="/Shopify-custom-sections"
                    className="text-blue-500 underline hover:text-blue-700"
                  >
                    Go to Home
                  </Link>
                </div>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
